import React,{useEffect, useState} from 'react';
import config from '../../config/apiConfig';
import axios from 'axios';
import TarjetaMenu from '../Navegacion/TarjetaMenu';
import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/react";
import { usePlan } from '../context/PlanContext';

 function ConfigHome(props) {

    const  [items, setItems] = useState([]);
    const  [loading, setLoading] = useState(false);
    const { tieneMesas } = usePlan();
    
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    useEffect(()=>{
        let token = localStorage.getItem("token");      
        axios.defaults.headers.common["token"] = token;
        getItems()
    },[]);
    
    async function getItems(){
        setLoading(true)
        await axios.get(config.api_url+'/configuracion/menu/items/?menuId=5').then(resp=>{
            console.log(resp.data)
            if (resp.data.completado){
                 setItems(resp.data.items)
                 setLoading(false)
            }
        }).catch(error=>{
            setLoading(false)
            alert('Se ha provocado un error');
        })
    }

    // 🚩 "Mesas" depende del Plan Restaurante: la ruta ya está bloqueada,
    // pero sin esto el tile queda visible igual y lleva a un dead-end.
    const itemsVisibles = tieneMesas ? items : items.filter(item => !item.url || !item.url.includes('/admin/mesas'));
      
   return (
        /* w-100 para que el formulario use todo el ancho */
        <div className="card w-100" style={{height:"100vh"}}>
            <div className="card-header">
                <div className="d-flex justify-content-center titulo-formulario">
                    <i className="bi bi-sliders"></i> &nbsp; Configuración 
                </div>   
            </div>
            {/* 🚩 CORREGIDO: card-body (tenías car-body). Esto arregla los márgenes */}
            <div className="card-body" style={{paddingLeft:"5%", paddingRight:"5%"}}>
                <br/>
                <BeatLoader color={config.color_loader} loading={loading} css={override} size={50} />
                
                {/* 🚩 Agregado 'row-cols-4' para que la fila sepa que van 4 cajas y no las aplaste */}
                <div className="row row-cols-1 row-cols-md-4 g-4">
                {itemsVisibles.map(item=>
                    <TarjetaMenu item={item}/>
                )}
                </div>
                <br/>
            </div>
        </div>
    );
}

export default ConfigHome;